import { create, destroy, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';
import { subscribe } from 'pub-sub';
import { createNlsMiddleware, lccstate, userstate, registry, rcslocationChangeProcess, userstore } from 'lcc-state';
import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';
const icache = createICacheMiddleware();
const nls = createNlsMiddleware('settings');
const factory = create({
    icache,
    theme,
    nls,
    lccstate,
    userstate,
    destroy
}).properties();
export const RcsPane = factory(({ properties, middleware: { icache, nls, userstate, destroy } }) => {
    icache.getOrSet('aboutToChange', false);
    const { baseurl: defaultbaseurl, openaction, onClose } = properties();
    const { get, path } = userstate;
    icache.getOrSet('baseurl', defaultbaseurl);
    icache.getOrSet('path', defaultbaseurl);
    const open = icache.getOrSet('open', () => {
        const hnd = [
            subscribe(openaction, async (topic, selectedpath) => {
                icache.set('aboutToChange', true);
                if (!selectedpath) {
                    selectedpath = `/${topic.split('/').slice(2).join('/')}`;
                }
                const selectedbase = selectedpath.split('/').slice(0, 3).join('/');
                icache.set('baseurl', selectedbase);
                icache.set('path', selectedpath);
                rcslocationChangeProcess(userstore)({
                    baseurl: `${selectedbase}`,
                    location: `${selectedpath}`
                });
                await delay(200);
                icache.set('open', true);
            }),
            subscribe('close-all/panes', () => {
                icache.set('open', false);
            })
        ];
        destroy(() => hnd.forEach((h) => h.destroy()));
        return false;
    });
    const { vw } = viewport();
    const { messages: { rcs_title = '[settings] rcs_title' } } = nls();
    const base = icache.get('baseurl') || defaultbaseurl;
    const rcspath = icache.get('path') || defaultbaseurl;
    const key = `${base.replace('/', '-')}-pane`;
    const xqa = `rcs-pane-${open}`;
    return w(SlidingPane, {
        xqa,
        key,
        open,
        align: 'right',
        underlay: true,
        title: rcs_title,
        width: Math.min(vw, 1024),
        onRequestClose: () => {
            icache.set('open', false);
            icache.set('aboutToChange', async () => {
                await delay(500);
                return true;
            });
            const location = get(path('location'));
            const { sitealias, portal_site } = window.hcstatic;
            window.history.pushState({ location }, '', `/${sitealias || portal_site || ''}${location}`);
            onClose && onClose();
        }
    }, [w('ResourceCenter', { baseurl: base, url: rcspath })]);
});
registry.define('RcsPane', RcsPane);
